<app-plan-selection (selectedPlan)="SelectedPlan($event)"></app-plan-selection>

<div *ngIf="_showModal">
    <app-register-modal [site]="site" [planid]="_planId" (finished)="RegistrationComplete($event)"></app-register-modal>
</div>
